import React from 'react';
import { Link } from 'react-router-dom';

const NotFound = () => {
    return (
        <div className='h-[94vh] w-[100vw] mx-auto overflow-hidden mt-14'>
            <div className='bg-commingsoon h-full w-full bg-cover relative'>
                <div className="absolute inset-0 bg-richblack-900 opacity-70"></div>
                <div className='flex flex-col absolute justify-center items-center w-full top-32'>
                    <Link to={'/'}>
                        <div className='lg:text-9xl md:text-8xl text-7xl font-bold bg-gradient-to-b from-[#ffd89b] to-[#19547b] text-transparent bg-clip-text'>
                            4 0 4
                        </div>
                    </Link>
                    <div className='text-lg md:text-xl text-richblack-5 my-8'>
                        Page Not Found !
                    </div>
                </div>
            </div>
        </div>
    )
}

export default NotFound;